import {
  DateField,
  ImageField,
  RichTextField,
  Show,
  SimpleShowLayout,
  TextField,
} from "react-admin";

export const AchievementShow = (props) => {
  return (
    <Show {...props}>
      <SimpleShowLayout>
        <TextField source="name" />
        <RichTextField source="description" />
        <DateField source="createdDate" showTime />
        <DateField source="updatedDate" showTime />
        <ImageField
          source="images[0].link"
          title="images[0].name"
          sx={{
            "& img": { maxWidth: 100, maxHeight: 100, objectFit: "contain" },
          }}
        />
      </SimpleShowLayout>
    </Show>
  );
};

